// extracted by mini-css-extract-plugin
export default {"figure":"styles_figure__NRQmP","image":"styles_image__+w2Ex","figcaption":"styles_figcaption__VLUO1"};